export default class Timers {
    static async delayFor<T>(ms: number, action: any): Promise<T>{
        return await new Promise<T>(resolve => {setTimeout(resolve, 1000)}).then(action);
    }
}